// import isEmpty  from 'lodash/isEmpty';



let compName = 'items' 

const initialState = {
    list: [],
}

export default (state = initialState, action = {}) => {
    
    switch (action.type) {
        // This action is used anytime you modify list when ever you drag a row,
        // delete item, or add an item to the item list.
        case 'UPDATE_ITEM_LIST':  /* called when PicListsPage component mounts */
            console.log("action.list", action.list);
            return {
                list: action.list
            }
        default:
            return state;
    }
};






// WEBPACK FOOTER //
// ./src/reducers/items.js